import { render } from "./Validate2FA.vue?vue&type=template&id=4a9705d4&scoped=true"
import script from "./Validate2FA.vue?vue&type=script&lang=js"
export * from "./Validate2FA.vue?vue&type=script&lang=js"

import "./Validate2FA.vue?vue&type=style&index=0&id=4a9705d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9705d4"]])

export default __exports__